/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_SubInputs */

const en_mk_how_sub = /** @type {(inputs: Mk_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with your needs, agree on the steps, then build and review the results with Bystep.`)
};

const id_mk_how_sub = /** @type {(inputs: Mk_How_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari kebutuhanmu, sepakati langkahnya, lalu bangun dan tinjau hasil bersama Bystep.`)
};

/**
* | output |
* | --- |
* | "Start with your needs, agree on the steps, then build and review the results with Bystep." |
*
* @param {Mk_How_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_sub = /** @type {((inputs?: Mk_How_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_sub(inputs)
	return en_mk_how_sub(inputs)
});